import React, { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useIntl } from "gatsby-plugin-react-intl"

import Markdown from "../components/Markdown"

// Grabs a snippet from Contentful for easy string translation

const Snippet = ({ id, field, renderHtml, ...props }) => {
  const intl = useIntl()

  if (!id) {
    return "Please provide an id."
  }

  if (!field) {
    return "Please provide a field."
  }

  const data = useStaticQuery(graphql`
    query {
      allContentfulSnippet {
        edges {
          node {
            contentful_id
            header
            node_locale
            text {
              text
            }
            linkText
            linkUrl
          }
        }
      }
    }
  `)

  const match = useMemo(
    () =>
      data.allContentfulSnippet.edges.find(
        ({ node }) =>
          node.contentful_id === id && node.node_locale === intl.locale
      ),
    [data, id, intl.locale]
  )

  let result = field === "text" ? match?.node?.text?.text : match?.node[field]
  let renderedResult = renderHtml ? <Markdown>{result}</Markdown> : result

  return result ? renderedResult : "No snippet found."
}

export default Snippet
